export default __webpack_public_path__ + "static/media/interswitch_logo.7b400142.svg";